import { SCENARIOS } from '../domain/scenarios';
import type { ScenarioId } from '../domain/types';

interface Props {
  value: ScenarioId;
  onChange: (id: ScenarioId) => void;
  disabled: boolean;
}

export function ScenarioSelector({ value, onChange, disabled }: Props) {
  return (
    <fieldset disabled={disabled} style={{ border: 'none', margin: 0, padding: 0 }}>
      <legend className="panel__legend">Elige un escenario de fallo</legend>
      <ul className="scenario-list" role="radiogroup" aria-label="Escenario de fallo">
        {SCENARIOS.map((scenario) => (
          <li key={scenario.id}>
            <label className="scenario-option">
              <div className="scenario-option__title">
                <input
                  type="radio"
                  name="scenario"
                  value={scenario.id}
                  checked={value === scenario.id}
                  onChange={() => onChange(scenario.id)}
                />
                {scenario.title}
              </div>
              <p className="scenario-option__description">{scenario.description}</p>
            </label>
          </li>
        ))}
      </ul>
    </fieldset>
  );
}
